//------------------项目管理---------------------
// 软件SPEC单
export const ISRF = {
    isrfNo: 100,
    isrfName: 100,
    reqNo: 100,
    memo: 2000,
}

//------------------流程制品---------------------
// 流程域
export const PM = {
    pmNo: 100,
    pmName: 100,
}

// 业务流程
export const BF = {
    bfNo: 128,
    bfName: 100,
    bfDesc: 1000,
    bfMemo: 1000,
}

// 流程图
export const WF = {
    wfUserCode: 100,
    wfName: 64,
    memo: 2000,
}

// 子流程
export const BFDATAFLOW = {
    algKey: 100,
    algTitle: 256,
    catNode: 256,
}


//------------------知识模块---------------------
// 知识模块
export const RULEMRM = {
    rmNo: 100,
    rmName: 100,
    resume: 2000,
    memo: 2000,
}

// 重要规则
export const RULEMRMRULE = {
    ruleKey: 100,
    ruleTitle: 256,
    ruleUserCode: 2000,
    resume: 2000,
}


//------------------功能制品---------------------
// 功能域
export const FM = {
    fmUserCode: 100,
    fmName: 100,
    fmDesc: 4000,
}

// 程序模块
export const BD = {
    bdNo: 128,
    bdName: 100,
    memo: 4000,
}

// 业务术语
export const BDTERM = {
    termKey: 100,
    termTitle: 256,
    termUserCode: 100,
    catNode: 256,
}

// 业务规则
export const BDRULE = {
    ruleKey: 100,
    ruleTitle: 256,
    ruleUserCode: 100,
    ruleStar: 16,
    resume: 2000,
    url: 200,
    catNode: 256,
}

// 用户场景
export const BDSUMMARY = {
    algKey: 100,
    algTitle: 256,
    algUserCode: 100,
    catNode: 256,
}

// 程序能力
export const BDLOGIC = {
    ...BDRULE,
}

// 业务事件
export const BDEVENT = {
    eventKey: 100,
    eventTitle: 256,
    eventUserCode: 100,
    memo: 2000,
    catNode: 256,
}

// 业务事务方法
export const BDALG = {
    ...BDSUMMARY
}

// 业务基础方法
export const BDBASE = {
    ...BDSUMMARY
}



//------------------界面制品---------------------
// 界面入口
export const UM = {
    umUserCode: 100,
    umName: 100,
}

// 用户界面
export const UI = {
    uiUserCode: 100,
    uiName: 100,
    uiPgCode: 400,
    memo: 2000,
}

// 界面视图
export const UV = {
    uvUserCode: 100,
    uvName: 64,
    uvMode: 32,
    uvType: 32,
    pageType: 32,
    demoType: 16,
    memo: 2000,
}

// 界面规则
export const UIRULE = {
    ruleKey: 100,
    ruleTitle: 256,
    ruleUserCode: 100,
    ruleType: 16,
}

// 界面事件能力
export const UE = {
    ueName: 100,
    ueUserCode: 100,
    ueTypeCode: 30,
    ueCat: 100,
}

// 界面基础能力
export const UIALG = {
    algKey: 100,
    algTitle: 256,
    algUserCode: 100,
    catNode: 256,
}


//------------------接口制品---------------------
// 外联系统
export const LS = {
    lsName: 128,
    infIp: 50,
    infDomainName: 50,
    memo: 2000,
}

// 外联接口
export const LSI = {
    lsiNo: 100,
    lsiName: 100,
    reqProtocol: 16,
    reqType: 16,
    reqUrl: 200,
    memo: 2000,
}


//------------------用例制品---------------------
// 用例域
export const CM = {
    cmNo: 100,
    cmName: 100,
}

// 集成用例
export const UC = {
    sfNo: 128,
    sfName: 128,
    sfTypeCode: 16,
    sfKey: 1024,
    sfMemo: 1024,
    reqNo: 50,
}


//------------------库表制品---------------------
// 数据库
export const DB = {
    dbUserCode: 100,
    dbName: 50,
    dbmsCode: 30,
    dbDesc: 2000,
    softwareDesc: 2000,
    hardwareDesc: 100,
    networkDesc: 2000,
    deployIp: 50,
    deployDesc: 2000,
}

// 库表域
export const DM = {
    dmUserCode: 100,
    dmName: 100,
}

// 数据库实例
export const DBINS = {
    dbInsName: 64,
    dbInsDesc: 512,
    dbInsMemo: 200,
    dbTitle: 50,
    url: 1000,
    userName: 50,
    userPassword: 50,
    dbInsVersion: 64,
    dbInsIntranetIp: 512,
    dbInsInternetIp: 512,
    dbInsPort: 512,
    dbInsDriverId: 32,
    dbInsSchema: 512,
    dbInsUserName: 512,
    dbInsUserPassword: 512,
    dbInsStatus: 32,
    dbInsBu: 512,
    dbInsDm: 128,
    dbInsOm: 128,
    dbInsEnv: 128,
}


// 数据表
export const DT = {
    dtUserCode: 100,
    dtAlias: 100,
    dtName: 100,
    dtDesc: 2000,
    memo: 2000,
}

// 表字段
export const DF = {
    dfUserCode: 100,
    dfAlias: 100,
    dfName: 2000,
    dataTypeGrpCode: 100,
    dataTypeCode: 100,
    defVal: 200,
    dfCat: 100,
    dfDesc: 2000,
}


// 数据视图
export const DV = {
    dvUserCode: 128,
    dvName: 100,
    memo: 2000,
}


// 定制数据类型
export const CDT = {
    cdtUserCode: 100,
    cdtName: 100,
    cdtCat: 100,
    cdtDesc: 2000,
    memo: 2000,
}

// 序列码
export const CDTSEQVAL = {
    cdtSeqVal: 200,
    cdtSeqValName: 200,
    cdtSeqValEn: 200,
    cdtSeqValDesc: 2000,
    memo: 2000,
}


// 标准字段组
export const PCDG = {
    pcdgUserCode: 100,
    pcdgName: 100,
    pcdgCat: 100,
    memo: 2000,
}

// 标准字段
export const DGF = {
    dfUserCode: 100,
    dfName: 100,
    dataTypeGrpCode: 30,
    dataTypeCode: 100,
    defVal: 200,
    dfCat: 100,
    dfDesc: 2000,
}


//------------------程序制品---------------------
// 子系统
export const SS = {
    ssUserCode: 100,
    ssName: 100,
    ssDir: 128,
    isUi: 1,
    terminalType: 16,
    ssDesc: 50,
    devLang: 50,
    devTechDesc: 2000,
    softwareDesc: 2000,
    hardwareDesc: 100,
    networkDesc: 2000,
    deployIp: 50,
    deployDesc: 2000,
    contextPath: 128,
    mainPackage: 1000,
}

// 程序模块
export const VM = {
    vmUserCode: 100,
    vmName: 100,
    vmPack: 100,
}

// 子系统实例
export const SSINS = {
    ssInsName: 64,
    ssInsDesc: 512,
    ssInsMemo: 2000,
    ssInsPort: 512,
    ssInsStatus: 32,
    ssInsBu: 512,
    ssInsDm: 128,
    ssInsOm: 128,
    ssInsEnv: 128,
}

// 程序能力
export const FC = {
    fcUserCode: 100,
    fcPgCode: 512,
    fcSign: 512,
    fcName: 100,
    fcType: 32,
    fcUg: 2000,
    perfDesc: 2000,
    inDesc: 2000,
    procDesc: 2000,
    outDesc: 2000,
    reqUrl: 200,
}

// DTO
export const DTO = {
    dtoUserCode: 100,
    dtoName: 100,
    dtoCat: 100,
    dtoDesc: 100,
}

// DTO字段
export const DTF = {
    dfUserCode: 100,
    dfName: 100,
    dataTypeGrpCode: 30,
    dataTypeCode: 100,
    dfCat: 100,
    dfDesc: 2000,
}


//------------------部署制品---------------------
// 物理服务器
export const PHYS = {
    psName: 64,
    psDesc: 512,
    psMemo: 2000,

    psHostname: 512,
    psIntranetIp: 512,
    psInternetIp: 512,
    psOs: 128,
    psKernelVersion: 128,
    psOpenPort: 512,
    psStatus: 32,

    psBu: 512,
    psDm: 128,
    psOm: 128,
    psEnv: 128,
    psSerialNumber: 256,

    psModel: 512,
    psCpu: 512,
    psMemory: 512,
    psHardDisk: 512,
    psMac: 512,
    psLocation: 512,
    psManufacturer: 512,
}

// 虚拟服务器
export const VR = {
    vsName: 64,
    vsDesc: 512,
    vsMemo: 2000,

    vsHostname: 512,
    vsIntranetIp: 512,
    vsInternetIp: 512,
    vsOs: 128,
    vsKernelVersion: 128,
    vsOpenPort: 512,
    vsStatus: 32,

    vsBu: 512,
    vsDm: 128,
    vsOm: 128,
    vsEnv: 128,

    vsCpu: 512,
    vsMemory: 512,
    vsHardDisk: 512,
    vsMac: 512,
}


//------------------组织制品---------------------
// 组织域
export const OM = {
    omNo: 100,
    omName: 100,
}

// 组织对象
export const OO = {
    ooNo: 100,
    ooName: 100,
    ooFullName: 100,
    memo: 2000,
    resume: 2000,
}

// 组织单元
export const OU = {
    ouName: 256,
    ouUserCode: 100,
    catNode: 256,
    resume: 2000,
}

// 岗位角色
export const OR = {
    orName: 256,
    orUserCode: 100,
    catNode: 256,
    resume: 2000,
}


//------------------分析制品---------------------
// 分析域
export const AM = {
    amNo: 100,
    amName: 100,
}

// 维度对象
export const DO = {
    doNo: 100,
    doName: 100,
    memo: 2000,
    resume: 2000,
}

// 维度实体
export const DE = {
    deTitle: 256,
    deUserCode: 100,
    catNode: 256,
    resume: 2000,
}


// 分析对象
export const AO = {
    aoNo: 100,
    aoName: 100,
    memo: 2000,
    resume: 2000,
}

// 指标实体
export const IE = {
    ieTitle: 256,
    ieUserCode: 100,
    dataType: 100,
    dataLen: 100,
    dataUnit: 100,
    catNode: 256,
    resume: 2000,
}

// 分析维度
export const AD = {
    adTitle: 256,
    adUserCode: 100,
    catNode: 256,
    resume: 2000,
}


// 分析指标
export const AMAI = {
    aiNo: 100,
    aiName: 100,
    aiNameEn: 200,
    aiAlias: 100,
    aiSf: 16,
    memo: 2000,
    resume: 2000,
}

// 分析口径
export const AIAC = {
    acUserCode: 100,
    acName: 100,
    catNode: 256,
    memo: 2000,
    resume: 2000,
}


// 分析报表
export const AMAR = {
    arNo: 100,
    arName: 100,
    memo: 2000,
    resume: 2000,
}

// 报表维度
export const ARRD = {
    rdUserCode: 100,
    rdName: 100,
    rdTitle: 100,
    catNode: 256,
    memo: 2000,
    resume: 2000,
}

// 报表指标
export const ARRI = {
    riUserCode: 100,
    riName: 100,
    riTitle: 100,
    catNode: 256,
    memo: 2000,
    resume: 2000,
}
